import { useReduxState } from 'hooks';
import { Icon } from 'components/common/icons';

interface Props {
  discrepancyInCompletion?: boolean;
  value: number | React.ReactNode;
}

const ProgressValue = ({ discrepancyInCompletion, value }: Props) => {
  const { messages } = useReduxState();

  return (
    <span
      {...(discrepancyInCompletion
        ? {
            'aria-label': messages.tasksUsersCompletionDiscrepancy,
            'data-tooltip': messages.tasksUsersCompletionDiscrepancy
          }
        : {})}
    >
      {value}

      {discrepancyInCompletion ? (
        <span className="discrepancy">
          <Icon icon="asterisk" />
        </span>
      ) : null}

      <style jsx>{`
        .discrepancy {
          font-size: 0.6rem;
          padding: 0 2px;
          vertical-align: top;
        }
      `}</style>
    </span>
  );
};

export default ProgressValue;
